/*
 * @Description: 公司设置
 * @Author: 杨志航
 * @Date: 2026-09-16 09:33:02
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  message,
  Spin,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item

const EditCompany = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue, getFieldValue } = props.form
  const { setVisible, editData, getList } = props
  const [saveLoading, setSaveLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const { name, leaderName, staffNo } = editData
    setFieldsValue({
      name,
      leaderName,
      staffNo,
    })
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { cid } = editData
        vals = filterParams(vals)
        vals = {
          id: cid,
          ...vals,
        }
        setSaveLoading(true)
        api.updateProfitReportCompanyName(vals).then(() => {
          setSaveLoading(false)
          setVisible(false)
          message.success('设置成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  const blurStaffNo = value => {
    if (value) {
      setLoading(true)
      api.getProfitReportStaffInfo({
        staffNo: value
      }).then(data => {
        setLoading(false)
        const leaderName = getFieldValue('leaderName')
        if (data && leaderName === '') {
          const { staffName } = data
          setFieldsValue({
            leaderName: staffName
          })
        }
      }).catch(() => setLoading(false))
    }
  }

  return (
    <Spin spinning={loading}>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="OA公司简称">
          {editData.companyName || '--'}
        </FormItem>
        <FormItem label="小程序公司名称">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: '请输入小程序公司名称' }]
          })(
            <Input placeholder="请输入小程序公司名称" />
          )}
        </FormItem>
        <FormItem label="公司负责人员工编号">
          {getFieldDecorator('staffNo', {
            rules: [{ required: true, message: '请输入公司负责人员工编号' }]
          })(
            <Input 
              placeholder="请输入公司负责人员工编号" 
              onBlur={evt => blurStaffNo(evt.target.value.trim())}
            />
          )}
        </FormItem>
        <FormItem label="小程序公司负责人">
          {getFieldDecorator('leaderName', {
            rules: [{ required: true, message: '请输入小程序中显示的负责人姓名' }]
          })(
            <Input placeholder="请输入小程序中显示的负责人姓名" />
          )}
        </FormItem>
        <BtnGroup onCancel={() => setVisible(false)} loading={saveLoading} />
      </Form>
    </Spin>
  );
}

export default Form.create()(EditCompany)
